import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartDataPoint } from '../utils/dailyDataProcessor';
import { getXAxisTicks } from '../utils/dailyChartUtils';

type SingleChartProps = {
  title: string;
  data: ChartDataPoint[];
  color: string;
  unit?: string;
  yAxisDomain?: [number, number];
  yAxisTicks?: number[];
  yAxisFormatter?: (value: number) => string;
  valueFormatter?: (value: any) => string;
  lineType?: 'monotone' | 'stepAfter';
  reversed?: boolean;
};

export const SingleChart: React.FC<SingleChartProps> = ({
  title,
  data,
  color,
  unit = '',
  yAxisDomain,
  yAxisTicks,
  yAxisFormatter,
  valueFormatter,
  lineType = 'monotone',
  reversed = false,
}) => {
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const dataPoint = payload[0].payload;
      const formattedValue = valueFormatter ? valueFormatter(dataPoint.value) : `${dataPoint.value}${unit}`;
      return (
        <div className="bg-white p-3 border border-gray-300 rounded-md shadow-lg">
          <p className="font-medium">{`時刻: ${dataPoint.time}`}</p>
          <p className="text-blue-600">{`${title}: ${formattedValue}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">{title}</h3>
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer>
          <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              dataKey="time"
              ticks={getXAxisTicks(data)}
              axisLine={{ stroke: '#d1d5db' }}
              tickLine={{ stroke: '#d1d5db' }}
              tick={{ fill: '#374151', fontSize: 12 }}
            />
            <YAxis 
              domain={yAxisDomain}
              ticks={yAxisTicks}
              axisLine={{ stroke: '#d1d5db' }}
              tickLine={{ stroke: '#d1d5db' }}
              tick={{ fill: '#374151', fontSize: 12 }}
              tickFormatter={yAxisFormatter}
              reversed={reversed}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type={lineType}
              dataKey="value"
              stroke={color}
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
